export const contentData = {
  spanish:{
    nodata:'Sin Registro',
    layout:{
      title:'Distribuidores',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Distribuidores',path:'/catalogs/providers'}
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
      
    },
    filters:[ 
      {id:null, label:'Sin Filtro', url:null},
    ],
    modals:{
      warning_modal:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      }
    },
    header:['ID','Nombre','E-mail', 'CRM ID', 'UCI']
  }
}